import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { Page } from '../../../../_shared/data/models/Page';
import { Referral } from '../models/referrals.model';
import { getLostReferrals } from '../requests/referrals.request';

export function useLostReferrals(partnerId: string) {
  const [referralsPage, setReferralsPage] = useState<Page<Referral>>({
    items: [],
    search: '',
    totalItems: 0,
    current: 1,
  });

  const { request: fetchReferralsPage, status } = useRequest(
    async ({ page, search }: { page: number; search: string }) => {
      if (!partnerId) {
        return;
      }
      setReferralsPage(await getLostReferrals(partnerId, { page, search }));
    },
    { requestOnMount: true, initialParams: { page: 1, search: '' } }
  );

  return {
    referralsPage,
    fetchReferralsPage,
    isSettled: status.isError || status.isSuccess,
  };
}
